import React from 'react';
import { useTranslation } from 'react-i18next';
import StatsPanel from '../components/StatsPanel';
import StudentAlertsPreview from '../components/StudentAlertsPreview';
import StudentAbsenceGrid from '../components/StudentAbsenceGrid';
import PageHeader from '../../../../components/Common/PageHeader';
import useAbsenceStats from '../hooks/useAbsenceStats';
import useAlertStudents from '../hooks/useAlertStudents';
import '../../../../components/Common/styles/skeleton.css';

const AbsenceOverviewPage: React.FC = () => {
  const { t } = useTranslation();
  const { stats, loading: statsLoading } = useAbsenceStats();
  const { alerts, loading: alertsLoading } = useAlertStudents(3); // Limit to 3 alerts for preview

  // Determine if any data is loading
  const isLoading = statsLoading || alertsLoading;

  // Define breadcrumb items for the page header
  const breadcrumbItems = [
    { label: 'dashboard', path: '/dashboard' },
    { label: 'absence_overview', active: true }
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader 
          title={t('absence_overview')} 
          breadcrumbItems={breadcrumbItems} 
        />

        {/* Stats Panel */}
        <StatsPanel stats={stats} loading={statsLoading} />

        <div className="row mt-4">
          {/* Student Alerts Preview */}
          <div className="col-md-4 mb-4">
            <StudentAlertsPreview alerts={alerts} loading={alertsLoading} />
          </div>

          {/* Student Absence Grid */}
          <div className="col-md-8">
            <StudentAbsenceGrid />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AbsenceOverviewPage;